import { loadView } from '@/router'

export default [
  {
    path: 'edi',
    name: 'manage-edi',
    component: loadView('Application/Manage/EDI'),
    showInAlfred: true,
    alfredTitle: 'Manage - EDI'
  }
]
